import { ElementRef } from '@angular/core';
import { Router } from "@angular/router";
import { FormBuilder, Validators } from "@angular/forms";
import { AccountService } from '../../core/auth/account.service';
import { PasswordService } from '../../account/password/password.service';
import { COUNTRIES, TIMEZONES } from '../../app.constants';
import { FindLanguageFromKeyPipe } from '../../shared/language/find-language-from-key.pipe';
import { SessionStorageService } from "ngx-webstorage";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TrackerService } from '../../core/tracker/tracker.service';
import { LeaveNumberModalComponent } from '../login/leave-number-modal.component';
import { UserService } from '../../core/user/user.service';
import { UserVoucherService } from '../user-voucher/user-voucher.service';
import { LoginService } from '../../core/login/login.service';
import { NotificationPreferenceService } from '../notification-preference/notification-preference.service';
import { NotificationPreference } from '../../shared/model/notification-preference.model';
import moment from "moment";
import { SecurityPolicyService } from '../../admin/security-policy/security-policy.service';
import { JhiLanguageService } from '../../ng-jhipster/language';
import { JhiEventManager } from '../../ng-jhipster/service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../../core/auth/account.service";
import * as i3 from "../../core/user/user.service";
import * as i4 from "../user-voucher/user-voucher.service";
import * as i5 from "@ng-bootstrap/ng-bootstrap";
import * as i6 from "../../account/password/password.service";
import * as i7 from "../../shared/language/find-language-from-key.pipe";
import * as i8 from "../../ng-jhipster/language";
import * as i9 from "ngx-webstorage";
import * as i10 from "../../core/tracker/tracker.service";
import * as i11 from "@angular/forms";
import * as i12 from "../../ng-jhipster/service";
import * as i13 from "../../core/login/login.service";
import * as i14 from "../notification-preference/notification-preference.service";
import * as i15 from "../../admin/security-policy/security-policy.service";
import * as i16 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i17 from "@angular/common";
import * as i18 from "@angular/material/form-field";
import * as i19 from "@angular/material/input";
import * as i20 from "@angular/material/select";
import * as i21 from "@angular/material/core";
import * as i22 from "@angular/material/button";
import * as i23 from "@angular/material/icon";
import * as i24 from "@angular/material/slide-toggle";
import * as i25 from "@ngx-translate/core";
const _c0 = ["userName"];
const _c1 = ["userEmail"];
function UserSettingsComponent_div_18_mat_error_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "register.messages.error.usernameRequired"), " ");
} }
function UserSettingsComponent_div_18_mat_error_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "register.messages.error.usernameMaxTwenty"), " ");
} }
function UserSettingsComponent_div_18_mat_error_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "register.messages.error.numberLetterOnly"), " ");
} }
function UserSettingsComponent_div_18_mat_error_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "register.messages.error.emailRequired"), " ");
} }
function UserSettingsComponent_div_18_mat_error_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "register.messages.error.invalidEmail"), " ");
} }
function UserSettingsComponent_div_18_mat_option_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const timezone_r11 = ctx.$implicit;
    i0.ɵɵproperty("value", timezone_r11);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(timezone_r11);
} }
function UserSettingsComponent_div_18_mat_option_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const country_r12 = ctx.$implicit;
    i0.ɵɵproperty("value", country_r12);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(country_r12);
} }
const _c2 = function (a0) { return { "readonly-input": a0 }; };
function UserSettingsComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "form", 13);
    i0.ɵɵlistener("ngSubmit", function UserSettingsComponent_div_18_Template_form_ngSubmit_1_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.updateAccountInfo(); });
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵelementStart(3, "div", 14);
    i0.ɵɵelementStart(4, "div", 15);
    i0.ɵɵelementStart(5, "mat-form-field", 16);
    i0.ɵɵelementStart(6, "mat-label");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "input", 17);
    i0.ɵɵlistener("ngModelChange", function UserSettingsComponent_div_18_Template_input_ngModelChange_9_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.account.login = $event; });
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, UserSettingsComponent_div_18_mat_error_11_Template, 3, 3, "mat-error", 12);
    i0.ɵɵtemplate(12, UserSettingsComponent_div_18_mat_error_12_Template, 3, 3, "mat-error", 12);
    i0.ɵɵtemplate(13, UserSettingsComponent_div_18_mat_error_13_Template, 3, 3, "mat-error", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "mat-form-field", 18);
    i0.ɵɵelementStart(15, "mat-label");
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "input", 19);
    i0.ɵɵlistener("ngModelChange", function UserSettingsComponent_div_18_Template_input_ngModelChange_18_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.account.email = $event; });
    i0.ɵɵpipe(19, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(20, UserSettingsComponent_div_18_mat_error_20_Template, 3, 3, "mat-error", 12);
    i0.ɵɵtemplate(21, UserSettingsComponent_div_18_mat_error_21_Template, 3, 3, "mat-error", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "div", 3);
    i0.ɵɵelementStart(23, "div", 14);
    i0.ɵɵelementStart(24, "div", 15);
    i0.ɵɵelementStart(25, "mat-form-field", 16);
    i0.ɵɵelement(26, "mat-label", 20);
    i0.ɵɵelementStart(27, "mat-select", 21);
    i0.ɵɵlistener("valueChange", function UserSettingsComponent_div_18_Template_mat_select_valueChange_27_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.account.timezone = $event; });
    i0.ɵɵtemplate(28, UserSettingsComponent_div_18_mat_option_28_Template, 2, 2, "mat-option", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "mat-form-field", 16);
    i0.ɵɵelement(30, "mat-label", 23);
    i0.ɵɵelementStart(31, "mat-select", 21);
    i0.ɵɵlistener("valueChange", function UserSettingsComponent_div_18_Template_mat_select_valueChange_31_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r18 = i0.ɵɵnextContext(); return ctx_r18.account.country = $event; });
    i0.ɵɵtemplate(32, UserSettingsComponent_div_18_mat_option_32_Template, 2, 2, "mat-option", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(33, "div", 24);
    i0.ɵɵelement(34, "button", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    let tmp_4_0;
    let tmp_5_0;
    let tmp_6_0;
    let tmp_12_0;
    let tmp_13_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r0.accountInfoForm);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 18, "settings.placeholder.accountName"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(10, 20, "settings.placeholder.accountName"));
    i0.ɵɵproperty("ngModel", ctx_r0.account.login);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (tmp_4_0 = ctx_r0.accountInfoForm.get("login")) == null ? null : tmp_4_0.errors == null ? null : tmp_4_0.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_5_0 = ctx_r0.accountInfoForm.get("login")) == null ? null : tmp_5_0.errors == null ? null : tmp_5_0.errors.maxlength);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_6_0 = ctx_r0.accountInfoForm.get("login")) == null ? null : tmp_6_0.errors == null ? null : tmp_6_0.errors.pattern);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(26, _c2, (ctx_r0.securityPolicy == null ? null : ctx_r0.securityPolicy.identityProvider) !== "INTERNAL"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 22, "settings.placeholder.emailAddress"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(19, 24, "settings.placeholder.emailAddress"));
    i0.ɵɵproperty("ngModel", ctx_r0.account.email)("readonly", (ctx_r0.securityPolicy == null ? null : ctx_r0.securityPolicy.identityProvider) !== "INTERNAL");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (tmp_12_0 = ctx_r0.accountInfoForm.get("email")) == null ? null : tmp_12_0.errors == null ? null : tmp_12_0.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_13_0 = ctx_r0.accountInfoForm.get("email")) == null ? null : tmp_13_0.errors == null ? null : tmp_13_0.errors.email);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("value", ctx_r0.account.timezone);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.timezones);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r0.account.country);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.countries);
} }
function UserSettingsComponent_div_19_mat_error_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "settings.messages.error.currentPasswordRequired"), " ");
} }
function UserSettingsComponent_div_19_mat_error_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "settings.messages.error.atLeast8"), " ");
} }
function UserSettingsComponent_div_19_mat_error_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "settings.messages.error.maxlength"), " ");
} }
function UserSettingsComponent_div_19_mat_error_26_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "settings.messages.error.newPasswordRequired"), " ");
} }
function UserSettingsComponent_div_19_mat_error_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "settings.messages.error.atLeast8"), " ");
} }
function UserSettingsComponent_div_19_mat_error_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "settings.messages.error.maxlength"), " ");
} }
function UserSettingsComponent_div_19_mat_error_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "settings.messages.error.confirmPasswordRequired"), " ");
} }
function UserSettingsComponent_div_19_mat_error_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "settings.messages.error.doNotMatch"), " ");
} }
function UserSettingsComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "form", 27);
    i0.ɵɵlistener("ngSubmit", function UserSettingsComponent_div_19_Template_form_ngSubmit_1_listener() { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(); return ctx_r27.updatePassword(); });
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵelementStart(3, "div", 14);
    i0.ɵɵelementStart(4, "div", 15);
    i0.ɵɵelementStart(5, "mat-form-field", 16);
    i0.ɵɵelementStart(6, "mat-label");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "input", 28);
    i0.ɵɵpipe(10, "translate");
    i0.ɵɵelementStart(11, "button", 29);
    i0.ɵɵlistener("click", function UserSettingsComponent_div_19_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r28); const ctx_r29 = i0.ɵɵnextContext(); return ctx_r29.hideCurrent = !ctx_r29.hideCurrent; });
    i0.ɵɵelementStart(12, "mat-icon", 30);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, UserSettingsComponent_div_19_mat_error_14_Template, 3, 3, "mat-error", 12);
    i0.ɵɵtemplate(15, UserSettingsComponent_div_19_mat_error_15_Template, 3, 3, "mat-error", 12);
    i0.ɵɵtemplate(16, UserSettingsComponent_div_19_mat_error_16_Template, 3, 3, "mat-error", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "mat-form-field", 31);
    i0.ɵɵelementStart(18, "mat-label");
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(21, "input", 32);
    i0.ɵɵpipe(22, "translate");
    i0.ɵɵelementStart(23, "button", 29);
    i0.ɵɵlistener("click", function UserSettingsComponent_div_19_Template_button_click_23_listener() { i0.ɵɵrestoreView(_r28); const ctx_r30 = i0.ɵɵnextContext(); return ctx_r30.hideNew = !ctx_r30.hideNew; });
    i0.ɵɵelementStart(24, "mat-icon", 30);
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(26, UserSettingsComponent_div_19_mat_error_26_Template, 3, 3, "mat-error", 12);
    i0.ɵɵtemplate(27, UserSettingsComponent_div_19_mat_error_27_Template, 3, 3, "mat-error", 12);
    i0.ɵɵtemplate(28, UserSettingsComponent_div_19_mat_error_28_Template, 3, 3, "mat-error", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "mat-form-field", 31);
    i0.ɵɵelementStart(30, "mat-label");
    i0.ɵɵtext(31);
    i0.ɵɵpipe(32, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(33, "input", 33);
    i0.ɵɵpipe(34, "translate");
    i0.ɵɵelementStart(35, "button", 29);
    i0.ɵɵlistener("click", function UserSettingsComponent_div_19_Template_button_click_35_listener() { i0.ɵɵrestoreView(_r28); const ctx_r31 = i0.ɵɵnextContext(); return ctx_r31.hideConfirm = !ctx_r31.hideConfirm; });
    i0.ɵɵelementStart(36, "mat-icon", 30);
    i0.ɵɵtext(37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(38, UserSettingsComponent_div_19_mat_error_38_Template, 3, 3, "mat-error", 12);
    i0.ɵɵtemplate(39, UserSettingsComponent_div_19_mat_error_39_Template, 3, 3, "mat-error", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(40, "div", 24);
    i0.ɵɵelement(41, "button", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    let tmp_7_0;
    let tmp_8_0;
    let tmp_9_0;
    let tmp_16_0;
    let tmp_17_0;
    let tmp_18_0;
    let tmp_25_0;
    let tmp_26_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r1.passwordForm);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 27, "settings.placeholder.currentPassword"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(10, 29, "settings.placeholder.currentPassword"));
    i0.ɵɵproperty("type", ctx_r1.hideCurrent ? "password" : "text");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", "Hide password")("aria-pressed", ctx_r1.hideCurrent);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.hideCurrent ? "visibility_off" : "visibility");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_7_0 = ctx_r1.passwordForm.get("currentPassword")) == null ? null : tmp_7_0.errors == null ? null : tmp_7_0.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_8_0 = ctx_r1.passwordForm.get("currentPassword")) == null ? null : tmp_8_0.errors == null ? null : tmp_8_0.errors.minlength);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_9_0 = ctx_r1.passwordForm.get("currentPassword")) == null ? null : tmp_9_0.errors == null ? null : tmp_9_0.errors.maxlength);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(20, 31, "settings.placeholder.newPassword"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(22, 33, "settings.placeholder.newPassword"));
    i0.ɵɵproperty("type", ctx_r1.hideNew ? "password" : "text");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", "Hide password")("aria-pressed", ctx_r1.hideNew);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.hideNew ? "visibility_off" : "visibility");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_16_0 = ctx_r1.passwordForm.get("newPassword")) == null ? null : tmp_16_0.errors == null ? null : tmp_16_0.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_17_0 = ctx_r1.passwordForm.get("newPassword")) == null ? null : tmp_17_0.errors == null ? null : tmp_17_0.errors.minlength);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_18_0 = ctx_r1.passwordForm.get("newPassword")) == null ? null : tmp_18_0.errors == null ? null : tmp_18_0.errors.maxlength);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(32, 35, "settings.placeholder.confirmPassword"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(34, 37, "settings.placeholder.confirmPassword"));
    i0.ɵɵproperty("type", ctx_r1.hideConfirm ? "password" : "text");
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("aria-label", "Hide password")("aria-pressed", ctx_r1.hideConfirm);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.hideConfirm ? "visibility_off" : "visibility");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_25_0 = ctx_r1.passwordForm.get("confirmPassword")) == null ? null : tmp_25_0.errors == null ? null : tmp_25_0.errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (tmp_26_0 = ctx_r1.passwordForm.get("confirmPassword")) == null ? null : tmp_26_0.errors == null ? null : tmp_26_0.errors.doNotMatch);
} }
function UserSettingsComponent_div_20_mat_error_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "settings.messages.error.voucherRequired"), " ");
} }
function UserSettingsComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "form", 34);
    i0.ɵɵlistener("ngSubmit", function UserSettingsComponent_div_20_Template_form_ngSubmit_1_listener() { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(); return ctx_r33.updateVouchers(); });
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵelementStart(3, "div", 14);
    i0.ɵɵelementStart(4, "div", 15);
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵelement(6, "span", 35);
    i0.ɵɵelementStart(7, "span");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "mat-form-field", 16);
    i0.ɵɵelementStart(10, "mat-label");
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "input", 36);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵtemplate(15, UserSettingsComponent_div_20_mat_error_15_Template, 3, 3, "mat-error", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 24);
    i0.ɵɵelement(17, "button", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    let tmp_4_0;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r2.vouchersForm);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(ctx_r2.credits);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 5, "settings.placeholder.addVoucher"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(14, 7, "settings.placeholder.addVoucher"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (tmp_4_0 = ctx_r2.vouchersForm.get("voucher")) == null ? null : tmp_4_0.errors == null ? null : tmp_4_0.errors.required);
} }
function UserSettingsComponent_div_21_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵelement(1, "span", 45);
    i0.ɵɵelementStart(2, "mat-slide-toggle", 42);
    i0.ɵɵlistener("toggleChange", function UserSettingsComponent_div_21_div_20_Template_mat_slide_toggle_toggleChange_2_listener() { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(2); return ctx_r36.toggleUpdateAvailabilityReminderNotifications(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r35.acceptUpdateAvailabilityReminderNotifications);
} }
function UserSettingsComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "div", 14);
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵelement(4, "h2", 37);
    i0.ɵɵelement(5, "br");
    i0.ɵɵelement(6, "h3", 38);
    i0.ɵɵelement(7, "p", 39);
    i0.ɵɵelementStart(8, "div", 40);
    i0.ɵɵelement(9, "span", 41);
    i0.ɵɵelementStart(10, "mat-slide-toggle", 42);
    i0.ɵɵlistener("toggleChange", function UserSettingsComponent_div_21_Template_mat_slide_toggle_toggleChange_10_listener() { i0.ɵɵrestoreView(_r39); const ctx_r38 = i0.ɵɵnextContext(); return ctx_r38.toggleSelfScanReminders(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 40);
    i0.ɵɵelement(12, "span", 43);
    i0.ɵɵelementStart(13, "mat-slide-toggle", 42);
    i0.ɵɵlistener("toggleChange", function UserSettingsComponent_div_21_Template_mat_slide_toggle_toggleChange_13_listener() { i0.ɵɵrestoreView(_r39); const ctx_r40 = i0.ɵɵnextContext(); return ctx_r40.toggleBookSessionReminders(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 40);
    i0.ɵɵelement(15, "span", 44);
    i0.ɵɵelementStart(16, "mat-slide-toggle", 42);
    i0.ɵɵlistener("toggleChange", function UserSettingsComponent_div_21_Template_mat_slide_toggle_toggleChange_16_listener() { i0.ɵɵrestoreView(_r39); const ctx_r41 = i0.ɵɵnextContext(); return ctx_r41.toggleWorkshopInvitations(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 40);
    i0.ɵɵelement(18, "span", 45);
    i0.ɵɵelementStart(19, "mat-slide-toggle", 42);
    i0.ɵɵlistener("toggleChange", function UserSettingsComponent_div_21_Template_mat_slide_toggle_toggleChange_19_listener() { i0.ɵɵrestoreView(_r39); const ctx_r42 = i0.ɵɵnextContext(); return ctx_r42.toggleNewsletters(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(20, UserSettingsComponent_div_21_div_20_Template, 3, 1, "div", 46);
    i0.ɵɵelement(21, "hr", 47);
    i0.ɵɵelementStart(22, "div", 40);
    i0.ɵɵelement(23, "h3", 48);
    i0.ɵɵelementStart(24, "mat-slide-toggle", 42);
    i0.ɵɵlistener("toggleChange", function UserSettingsComponent_div_21_Template_mat_slide_toggle_toggleChange_24_listener() { i0.ɵɵrestoreView(_r39); const ctx_r43 = i0.ɵɵnextContext(); return ctx_r43.toggleSystemNotifications(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(25, "p", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("checked", ctx_r3.acceptSelfScanReminders);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("checked", ctx_r3.acceptBookSessionReminders);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("checked", ctx_r3.acceptWorkshopInvitations);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("checked", ctx_r3.acceptNewsletters);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.isCoach);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("checked", ctx_r3.acceptSystemNotifications);
} }
export class UserSettingsComponent {
    constructor(router, accountService, userService, userVoucherService, modalService, passwordService, findLanguageFromKeyPipe, languageService, sessionStorage, trackerService, fb, eventManager, loginService, notificationPreferenceService, securityPolicyService) {
        this.router = router;
        this.accountService = accountService;
        this.userService = userService;
        this.userVoucherService = userVoucherService;
        this.modalService = modalService;
        this.passwordService = passwordService;
        this.findLanguageFromKeyPipe = findLanguageFromKeyPipe;
        this.languageService = languageService;
        this.sessionStorage = sessionStorage;
        this.trackerService = trackerService;
        this.fb = fb;
        this.eventManager = eventManager;
        this.loginService = loginService;
        this.notificationPreferenceService = notificationPreferenceService;
        this.securityPolicyService = securityPolicyService;
        this.OK = 'OK';
        this.NOT_FOUND = 'Not Found';
        this.passwordTypeInput = 'password';
        this.confirmTypeInput = 'password';
        this.account = null;
        this.countries = COUNTRIES;
        this.timezones = TIMEZONES;
        this.selected = 'accountInfo';
        this.modalOptions = { windowClass: 'modal-window', size: 'md', centered: true };
        this.hideCurrent = true;
        this.hideNew = true;
        this.hideConfirm = true;
        this.accountInfoForm = this.fb.group({
            email: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(50), Validators.email]],
            login: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(20), Validators.pattern('^[_A-Za-z0-9]+$')]],
            country: ['', [Validators.required]],
            timezone: ['', [Validators.required]]
        });
        this.passwordForm = this.fb.group({
            currentPassword: ['', [Validators.required]],
            newPassword: ['', [Validators.required, Validators.minLength(8)]],
            confirmPassword: ['', [Validators.required, Validators.minLength(8)]]
        });
        this.vouchersForm = this.fb.group({
            voucher: ['', [Validators.required]],
        });
    }
    ngOnInit() {
        this.accountSubscription = this.accountService.getAuthenticationState().subscribe(account => {
            this.account = account;
            this.isCoach = this.account.authorities.includes('ROLE_COACH');
            this.initialCountry = this.account.country;
            this.initialEmail = this.account.email;
        });
        this.getNotificationSubscriptions();
        this.fetchCurrentVouchersAndCredit();
        this.fetchSecurityPolicy();
        this.eventManagerSubscription = this.eventManager.subscribe('inukaNgApp.httpError', (errorResponse) => {
            let response = errorResponse.content.status;
            if (response === 404) {
                this.openModal("payment.messages.noVoucher");
                return;
            }
            if (response === 410) {
                this.openModal("payment.messages.expired");
                return;
            }
            if (response === 403) {
                this.openModal("payment.messages.forbidden");
                return;
            }
            if (response === 302) {
                this.openModal("payment.messages.found");
                return;
            }
        });
    }
    fetchSecurityPolicy() {
        this.securityPolicyService.findFrontEndSecurityPolicyForCurrentUser().subscribe(response => {
            if (response === null || response === void 0 ? void 0 : response.ok) {
                this.securityPolicy = response.body;
            }
        });
    }
    getNotificationSubscriptions() {
        this.notificationPreferenceSubscription = this.notificationPreferenceService.queryForCurrentUser().subscribe(nps => {
            if (nps.body && nps.body.length > 0) {
                this.notificationPreferences = nps.body;
                let selfScanReminder = this.notificationPreferences.find(np => np.group === 'WELLBEING_SCAN_REMINDERS');
                if (selfScanReminder)
                    this.acceptSelfScanReminders = selfScanReminder.enabled;
                let bookSessionReminder = this.notificationPreferences.find(np => np.group === 'BOOK_SESSION_REMINDERS');
                if (bookSessionReminder)
                    this.acceptBookSessionReminders = bookSessionReminder.enabled;
                let workShopInvitation = this.notificationPreferences.find(np => np.group === 'WORKSHOP_INVITATIONS');
                if (workShopInvitation)
                    this.acceptWorkshopInvitations = workShopInvitation.enabled;
                let newsletter = this.notificationPreferences.find(np => np.group === 'NEWSLETTER');
                if (newsletter)
                    this.acceptNewsletters = newsletter.enabled;
                let systemNotification = this.notificationPreferences.find(np => np.group === 'SYSTEM_NOTIFICATIONS');
                if (systemNotification)
                    this.acceptSystemNotifications = systemNotification.enabled;
                let updateAvailabilityReminderNotifications = this.notificationPreferences.find(np => np.group === 'UPDATE_AVAILABILITY_REMINDERS');
                if (updateAvailabilityReminderNotifications)
                    this.acceptUpdateAvailabilityReminderNotifications = updateAvailabilityReminderNotifications.enabled;
            }
            else {
                this.notificationPreferences = [];
            }
            console.log(this.notificationPreferences);
        });
    }
    fetchCurrentVouchersAndCredit() {
        this.userSubscription = this.userService.current().subscribe(user => {
            this.currentUser = user;
            this.credits = this.currentUser.credits;
            this.userVoucherSubscription1 = this.userVoucherService.findList(this.currentUser.id).subscribe((res) => {
                this.currentUserVouchers = res.body || [];
            });
        });
    }
    updateAccountInfo() {
        this.accountInfoForm.patchValue({
            email: this.account.email,
            login: this.account.login,
            country: this.account.country,
            timezone: this.account.timezone,
        });
        if (this.accountInfoForm.valid) {
            this.accountInfoSubscription = this.accountService.save(this.account).subscribe(response => {
                console.log(response);
                if (response === this.OK) {
                    this.openModal("settings.messages.preferencesChanged");
                    this.changeLanguage(this.account.langKey);
                    if (this.initialCountry !== this.account.country) {
                        this.trackerService.sendActivity("userSettings_countryChanged", { 'country': this.account.country });
                        this.initialCountry = this.account.country;
                    }
                    if (this.initialEmail !== this.account.email) {
                        this.loginService.logout();
                    }
                }
                else if (response === this.NOT_FOUND) {
                    this.openModal("password.messages.userNameNotFound");
                }
            }, (errorResponse) => {
                let errorKey = JSON.parse(errorResponse.error).errorKey;
                console.log(errorResponse.error);
                console.log(errorKey);
                if (errorKey === 'userexists') {
                    this.modalElement = this.userName;
                    this.openModal("settings.messages.error.userexists");
                    return;
                }
                else if (errorKey === 'emailexists') {
                    this.modalElement = this.userEmail;
                    this.openModal("settings.messages.error.emailexists");
                    return;
                }
            });
        }
    }
    updatePassword() {
        let currentPassword = this.passwordForm.get(['currentPassword']).value;
        let newPassword = this.passwordForm.get(['newPassword']).value;
        let confirmPassword = this.passwordForm.get(['confirmPassword']).value;
        if (newPassword !== confirmPassword) {
            this.passwordForm.get(['confirmPassword']).setErrors({ doNotMatch: true });
        }
        if (this.passwordForm.valid) {
            this.passwordSubscription = this.passwordService.save(newPassword, currentPassword).subscribe(response => {
                console.log(response);
                if (response === this.OK) {
                    this.openModal("password.messages.passwordChanged");
                }
                else if (response === this.NOT_FOUND) {
                    this.openModal("password.messages.userNameNotFound");
                }
            }, error => {
                console.log(error);
                this.openModal("password.messages.passwordNotAuthenticated");
            });
        }
    }
    updateVouchers() {
        let voucherCode = this.vouchersForm.get('voucher').value;
        if (this.vouchersForm.valid) {
            this.userVoucherSubscription2 = this.userVoucherService.addCode(voucherCode).subscribe((res) => {
                if (res.statusText === this.OK) {
                    this.openModal("payment.messages.successful");
                    this.trackerService.sendActivity("userPayment_voucherAdded", { 'voucher_code': res.body.voucher.code });
                    this.fetchCurrentVouchersAndCredit();
                }
                else {
                    this.openModal("payment.messages.successful");
                }
            });
        }
    }
    openModal(message) {
        const modalRef = this.modalService.open(LeaveNumberModalComponent, this.modalOptions);
        modalRef.componentInstance.leaveNumberModalRef = modalRef;
        modalRef.componentInstance.displayNLHelpHeader = false;
        modalRef.componentInstance.errorMessage = message;
    }
    changeLanguage(languageKey) {
        this.sessionStorage.store('locale', languageKey);
        this.languageService.changeLanguage(languageKey);
    }
    switchTo(tab) {
        this.selected = tab;
    }
    getButtonColor(tab) {
        let result;
        if (this.selected === tab)
            result = 'btn-primary';
        else
            result = 'btn-secondary';
        return result;
    }
    toggleSelfScanReminders() {
        this.acceptSelfScanReminders = !this.acceptSelfScanReminders;
        this.updateNotifications(this.acceptSelfScanReminders, 'WELLBEING_SCAN_REMINDERS');
    }
    toggleBookSessionReminders() {
        this.acceptBookSessionReminders = !this.acceptBookSessionReminders;
        this.updateNotifications(this.acceptBookSessionReminders, 'BOOK_SESSION_REMINDERS');
    }
    toggleWorkshopInvitations() {
        this.acceptWorkshopInvitations = !this.acceptWorkshopInvitations;
        this.updateNotifications(this.acceptWorkshopInvitations, 'WORKSHOP_INVITATIONS');
    }
    toggleNewsletters() {
        this.acceptNewsletters = !this.acceptNewsletters;
        this.updateNotifications(this.acceptNewsletters, 'NEWSLETTER');
    }
    toggleSystemNotifications() {
        this.acceptSystemNotifications = !this.acceptSystemNotifications;
        this.updateNotifications(this.acceptSystemNotifications, 'SYSTEM_NOTIFICATIONS');
    }
    toggleUpdateAvailabilityReminderNotifications() {
        this.acceptUpdateAvailabilityReminderNotifications = !this.acceptUpdateAvailabilityReminderNotifications;
        this.updateNotifications(this.acceptUpdateAvailabilityReminderNotifications, 'UPDATE_AVAILABILITY_REMINDERS');
    }
    updateNotifications(enabled, group) {
        console.log(enabled);
        let np = this.notificationPreferences.find(inp => inp.group === group);
        if (np != null) {
            np.enabled = enabled;
            np.lastModifiedDate = moment();
            this.notificationPreferenceService.update(np).subscribe(np1 => {
                this.getNotificationSubscriptions();
            }, error1 => {
                console.log(error1);
            });
        }
        else {
            np = new NotificationPreference();
            np.group = group;
            np.enabled = enabled;
            np.channel = this.currentUser.whatsappConversationId ? 'WHATSAPP' : 'EMAIL';
            np.user = this.currentUser;
            np.createdDate = moment();
            np.lastModifiedDate = np.createdDate;
            this.notificationPreferenceService.create(np).subscribe(np2 => {
                this.getNotificationSubscriptions();
            }, error2 => {
                console.log(error2);
            });
        }
    }
    ngOnDestroy() {
        if (this.accountSubscription) {
            this.accountSubscription.unsubscribe();
        }
        if (this.userSubscription) {
            this.userSubscription.unsubscribe();
        }
        if (this.userVoucherSubscription1) {
            this.userVoucherSubscription1.unsubscribe();
        }
        if (this.userVoucherSubscription2) {
            this.userVoucherSubscription2.unsubscribe();
        }
        if (this.userVoucherSubscription3) {
            this.userVoucherSubscription3.unsubscribe();
        }
        if (this.passwordSubscription) {
            this.passwordSubscription.unsubscribe();
        }
        if (this.accountInfoSubscription) {
            this.accountInfoSubscription.unsubscribe();
        }
        if (this.eventManagerSubscription) {
            this.eventManagerSubscription.unsubscribe();
        }
        if (this.notificationPreferenceSubscription) {
            this.notificationPreferenceSubscription.unsubscribe();
        }
    }
}
UserSettingsComponent.ɵfac = function UserSettingsComponent_Factory(t) { return new (t || UserSettingsComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i2.AccountService), i0.ɵɵdirectiveInject(i3.UserService), i0.ɵɵdirectiveInject(i4.UserVoucherService), i0.ɵɵdirectiveInject(i5.NgbModal), i0.ɵɵdirectiveInject(i6.PasswordService), i0.ɵɵdirectiveInject(i7.FindLanguageFromKeyPipe), i0.ɵɵdirectiveInject(i8.JhiLanguageService), i0.ɵɵdirectiveInject(i9.SessionStorageService), i0.ɵɵdirectiveInject(i10.TrackerService), i0.ɵɵdirectiveInject(i11.FormBuilder), i0.ɵɵdirectiveInject(i12.JhiEventManager), i0.ɵɵdirectiveInject(i13.LoginService), i0.ɵɵdirectiveInject(i14.NotificationPreferenceService), i0.ɵɵdirectiveInject(i15.SecurityPolicyService)); };
UserSettingsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UserSettingsComponent, selectors: [["user-settings"]], viewQuery: function UserSettingsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.userName = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.userEmail = _t.first);
    } }, decls: 22, vars: 16, consts: [[1, "olha-theme"], [1, "container"], [1, "d-none", "d-sm-block"], [1, "d-flex", "justify-content-center"], [1, "col-12", "col-sm-12", "col-md-10", "col-lg-7", "card", "p-0", "mb-4", "switch-div"], ["jhiTranslate", "settings.headers.accountInfo", 1, "btn", "span", 3, "ngClass", "click"], ["jhiTranslate", "settings.headers.security", 1, "btn", "span", 3, "ngClass", "click"], ["jhiTranslate", "settings.headers.vouchers", 1, "btn", "span", 3, "ngClass", "click"], ["jhiTranslate", "settings.headers.notifications", 1, "btn", "span", 3, "ngClass", "click"], [1, "d-sm-none"], [1, "col-md-10", "col-lg-7", "card", "p-0", "mb-0", "switch-div", "switch-div-small-top"], [1, "col-12", "col-sm-12", "col-md-10", "col-lg-7", "card", "p-0", "mb-4", "switch-div", "switch-div-small-bottom"], [4, "ngIf"], ["name", "accountInfo", "role", "form", 3, "formGroup", "ngSubmit"], [1, "col-12", "col-sm-12", "col-md-10", "col-lg-7", "card", "form-card", "mb-4"], [1, "d-flex", "flex-column"], ["appearance", "outline"], ["matInput", "", "formControlName", "login", 3, "placeholder", "ngModel", "ngModelChange"], ["appearance", "outline", 3, "ngClass"], ["matInput", "", "formControlName", "email", 3, "placeholder", "ngModel", "readonly", "ngModelChange"], ["jhiTranslate", "settings.placeholder.timezone"], ["tabindex", "-1", 3, "value", "valueChange"], [3, "value", 4, "ngFor", "ngForOf"], ["jhiTranslate", "settings.placeholder.country"], [1, "text-center"], ["type", "submit", "jhiTranslate", "settings.form.saveChanges", 1, "btn", "btn-primary"], [3, "value"], ["name", "security", "role", "form", 3, "formGroup", "ngSubmit"], ["matInput", "", "formControlName", "currentPassword", 3, "placeholder", "type"], ["mat-icon-button", "", "matSuffix", "", 1, "m-0", "p-0", 3, "click"], ["inline", "true"], ["appearance", "outline", 1, ""], ["matInput", "", "formControlName", "newPassword", 3, "placeholder", "type"], ["matInput", "", "formControlName", "confirmPassword", 3, "placeholder", "type"], ["name", "vouchers", "role", "form", 3, "formGroup", "ngSubmit"], ["jhiTranslate", "payment.text"], ["matInput", "", "formControlName", "voucher", 3, "placeholder"], ["jhiTranslate", "settings.headers.notificationSettings"], ["jhiTranslate", "settings.headers.infoAndReminders"], ["jhiTranslate", "settings.likeToShare"], [1, "d-flex", "justify-content-between", "mt-2", "mb-2"], ["jhiTranslate", "settings.selfScanReminders"], [3, "checked", "toggleChange"], ["jhiTranslate", "settings.bookSessionReminders"], ["jhiTranslate", "settings.workShopInvitations"], ["jhiTranslate", "settings.newsletters"], ["class", "d-flex justify-content-between mt-2 mb-2", 4, "ngIf"], [2, "width", "100%"], ["jhiTranslate", "settings.systemNotifications"], ["jhiTranslate", "settings.youWillReceive"]], template: function UserSettingsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵelementStart(5, "span", 5);
        i0.ɵɵlistener("click", function UserSettingsComponent_Template_span_click_5_listener() { return ctx.switchTo("accountInfo"); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "span", 6);
        i0.ɵɵlistener("click", function UserSettingsComponent_Template_span_click_6_listener() { return ctx.switchTo("security"); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "span", 7);
        i0.ɵɵlistener("click", function UserSettingsComponent_Template_span_click_7_listener() { return ctx.switchTo("vouchers"); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "span", 8);
        i0.ɵɵlistener("click", function UserSettingsComponent_Template_span_click_8_listener() { return ctx.switchTo("notifications"); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 9);
        i0.ɵɵelementStart(10, "div", 3);
        i0.ɵɵelementStart(11, "div", 10);
        i0.ɵɵelementStart(12, "span", 5);
        i0.ɵɵlistener("click", function UserSettingsComponent_Template_span_click_12_listener() { return ctx.switchTo("accountInfo"); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "span", 6);
        i0.ɵɵlistener("click", function UserSettingsComponent_Template_span_click_13_listener() { return ctx.switchTo("security"); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 3);
        i0.ɵɵelementStart(15, "div", 11);
        i0.ɵɵelementStart(16, "span", 7);
        i0.ɵɵlistener("click", function UserSettingsComponent_Template_span_click_16_listener() { return ctx.switchTo("vouchers"); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "span", 8);
        i0.ɵɵlistener("click", function UserSettingsComponent_Template_span_click_17_listener() { return ctx.switchTo("notifications"); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(18, UserSettingsComponent_div_18_Template, 35, 28, "div", 12);
        i0.ɵɵtemplate(19, UserSettingsComponent_div_19_Template, 42, 39, "div", 12);
        i0.ɵɵtemplate(20, UserSettingsComponent_div_20_Template, 18, 9, "div", 12);
        i0.ɵɵtemplate(21, UserSettingsComponent_div_21_Template, 26, 6, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngClass", ctx.getButtonColor("accountInfo"));
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("d-none", (ctx.securityPolicy == null ? null : ctx.securityPolicy.identityProvider) !== "INTERNAL");
        i0.ɵɵproperty("ngClass", ctx.getButtonColor("security"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.getButtonColor("vouchers"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.getButtonColor("notifications"));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", ctx.getButtonColor("accountInfo"));
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("d-none", (ctx.securityPolicy == null ? null : ctx.securityPolicy.identityProvider) !== "INTERNAL");
        i0.ɵɵproperty("ngClass", ctx.getButtonColor("security"));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", ctx.getButtonColor("vouchers"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.getButtonColor("notifications"));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selected === "accountInfo");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selected === "security");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selected === "vouchers");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selected === "notifications");
    } }, directives: [i16.JhiTranslateDirective, i17.NgClass, i17.NgIf, i11.ɵNgNoValidate, i11.NgControlStatusGroup, i11.FormGroupDirective, i18.MatFormField, i18.MatLabel, i19.MatInput, i11.DefaultValueAccessor, i11.NgControlStatus, i11.FormControlName, i20.MatSelect, i17.NgForOf, i18.MatError, i21.MatOption, i22.MatButton, i18.MatSuffix, i23.MatIcon, i24.MatSlideToggle], pipes: [i25.TranslatePipe], styles: [".olha-theme[_ngcontent-%COMP%]{background-color:#f7f4eb;height:100%}fa-icon.eye[_ngcontent-%COMP%]{top:32px}input[_ngcontent-%COMP%], select[_ngcontent-%COMP%]{z-index:10;border-color:#000 !important;border-radius:19px !important}button[_ngcontent-%COMP%]{margin:24px auto 24px auto;border-radius:40px;width:200px;padding-top:3px !important;padding-bottom:3px !important}div.card-body[_ngcontent-%COMP%]{padding-bottom:0 !important}label[_ngcontent-%COMP%]{opacity:.5}.switch-div[_ngcontent-%COMP%]{display:grid;grid-auto-columns:minmax(0, 1fr);grid-auto-flow:column}.switch-div-small-top[_ngcontent-%COMP%]{border-bottom-left-radius:0;border-bottom-right-radius:0}.switch-div-small-bottom[_ngcontent-%COMP%]{border-top-left-radius:0;border-top-right-radius:0}.btn-secondary[_ngcontent-%COMP%]{border:none}.span[_ngcontent-%COMP%]{border-radius:8px;cursor:pointer}.container[_ngcontent-%COMP%]{padding-top:110px}.btn[_ngcontent-%COMP%]{padding:8px !important}.form-card[_ngcontent-%COMP%]{padding:30px 20px 30px 20px}[_nghost-%COMP%]  .mat-radio-button, [_nghost-%COMP%]  .mat-form-field, [_nghost-%COMP%]  .mat-select{font-family:\"Open Sans\",sans-serif !important;font-size:16px !important}[_nghost-%COMP%]  .mat-radio-button.mat-accent .mat-radio-inner-circle, [_nghost-%COMP%]  .mat-radio-button.mat-accent .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple), [_nghost-%COMP%]  .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-persistent-ripple, [_nghost-%COMP%]  .mat-radio-button.mat-accent:active .mat-radio-persistent-ripple{background-color:#44a38d}[_nghost-%COMP%]  .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle, [_nghost-%COMP%]  .mat-radio-outer-circle{border-color:#44a38d}[_nghost-%COMP%]  .mat-form-field-appearance-outline .mat-form-field-outline{color:#cce9e0 !important}[_nghost-%COMP%]  .mat-form-field-appearance-outline .mat-form-field-outline-thick{color:var(--main) !important}[_nghost-%COMP%]  .mat-slide-toggle.mat-checked:not(.mat-disabled) .mat-slide-toggle-bar{background:#44a38d}[_nghost-%COMP%]  .mat-slide-toggle.mat-checked:not(.mat-disabled) .mat-slide-toggle-thumb{background:#fff}[_nghost-%COMP%]  .mat-slide-toggle .mat-slide-toggle-bar{background-color:#e1e1e1}[_nghost-%COMP%]  .mat-slide-toggle .mat-slide-toggle-thumb{background-color:#fff}[_nghost-%COMP%]  .readonly-input .mat-form-field-outline-start, [_nghost-%COMP%]  .readonly-input .mat-form-field-outline-gap, [_nghost-%COMP%]  .readonly-input .mat-form-field-outline-end{background-color:#f2f9f7}[_nghost-%COMP%]  .readonly-input .mat-form-field-infix{color:#7cbfae}@media(min-width: 576px){.btn[_ngcontent-%COMP%]{padding:8px 16px 8px 16px !important}.form-card[_ngcontent-%COMP%]{padding:30px 120px 30px 120px}}"] });
